import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Card, Row, Col, Button } from 'react-bootstrap';
import { getPersonList, deletePerson } from '../../actions/person';
import { getMatchParams, isRangeChanged, isToday, usePermission } from '../../helpers/common';
import { CardContainer, Icon, DataTable, Span, Modal } from '../widgets';

class PersonList extends React.Component {
    constructor() {
        super();
        this.state = {
            farmId: null,
            isEditMode: false,
            deleteModal: false,
            personInfo: null,
            personId: '',
            personName: ''
        };

        this.handleDelete = this.handleDelete.bind(this);
        this.handleDeleteConfim = this.handleDeleteConfim.bind(this);
    }

    componentDidMount() {
        const { farmId } = getMatchParams(this.props.match.params);
        this.setState({ farmId });
        this.props.dispatch(getPersonList({ farmId }));
    }

    componentDidUpdate(prevProps) {
        if (isRangeChanged(prevProps.search, this.props.search))
            this.props.dispatch(getPersonList({ farmId: this.state.farmId }));
    }

    handleDelete(id, name) {
        this.setState({ personId: id, personName: name, deleteModal: true });
    }

    handleDeleteConfim() {
        this.props.dispatch(deletePerson({
            person_uuid: this.state.personId,
            farm_uuid: this.state.farmId
        }));
    }

    render() {
        const { isRequesting, search, personList } = this.props;
        const allow = usePermission();
        const isAllowCreate = allow("person", "create") ? isToday(this.props.search.range) : false;
        const isAllowEdit = allow("person", "edit");
        const isAllowDelete = allow("person", "delete");

        return (
            <CardContainer>
                <Card className="card-list">
                    <Card.Header>
                        <Card.Title>
                            Person List
                            {isAllowCreate && <NavLink to={`add`}>
                                <Button variant="success" size="sm" className="float-right">
                                    <Icon className="fa fa-plus"></Icon> Add Person
                                </Button>
                            </NavLink>}
                        </Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <Row>
                            <Col>
                                <DataTable>
                                    <DataTable.Header>
                                        <DataTable.Row>
                                            <DataTable.Cell style={{ width: "40px" }}>#</DataTable.Cell>
                                            <DataTable.Cell>Name</DataTable.Cell>
                                            <DataTable.Cell>Role</DataTable.Cell>
                                            <DataTable.Cell>Mobile</DataTable.Cell>
                                            {(isAllowEdit || isAllowDelete) && <DataTable.Cell style={{ width: "64px" }}>Action</DataTable.Cell>}
                                        </DataTable.Row>
                                    </DataTable.Header>
                                    <DataTable.Body>
                                        {personList.map((e, i) => {
                                            return (<DataTable.Row className={!e.alive ? "not-alive-txt" : ""} key={i}>
                                                <DataTable.Cell style={{ width: "40px" }}>{i + 1}</DataTable.Cell>
                                                <DataTable.Cell>{e.name}</DataTable.Cell>
                                                <DataTable.Cell>{e.person_role_name}</DataTable.Cell>
                                                <DataTable.Cell>{e.phone}</DataTable.Cell>
                                                {(isAllowEdit || isAllowDelete) && <DataTable.Cell style={{ width: "64px" }} className="center">
                                                    {isToday(search.range) && e.alive && <>{isAllowEdit && <NavLink className="btn-icon mr-1" to={`edit/${e.person_uuid}`}>
                                                        <Icon className="fa fa-pencil" title="Edit"></Icon>
                                                    </NavLink>}
                                                        {isAllowDelete && <Span className="btn-icon">
                                                            <Icon className="fa fa-trash" title="Delete" id={e.person_uuid}
                                                                onClick={this.handleDelete.bind(this, e.person_uuid, e.name)}></Icon>
                                                        </Span>}</>}
                                                </DataTable.Cell>}
                                            </DataTable.Row>);
                                        })}
                                    </DataTable.Body>
                                </DataTable>
                                {isRequesting ? <DataTable.Loading /> :
                                    personList.length === 0 && <DataTable.RecordsNotFound />}
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                <Modal.Confirm
                    isOpen={this.state.deleteModal}
                    onConfirm={this.handleDeleteConfim}
                    iconClassName="fa fa-trash"
                    body={`Do you really want to delete these ${this.state.personName}?`}
                    onHide={() => { this.setState({ deleteModal: !this.state.deleteModal }); }} />
            </CardContainer>
        );
    }
}

const mapStateToProps = state => ({
    isRequesting: state.person.isRequesting,
    personList: state.person.personList,
    search: {
        rangeId: state.analyze.searchParams.rangeId,
        range: state.analyze.searchParams.range,
        customRange: state.analyze.searchParams.customRange,
        custom: state.analyze.searchParams.custom
    }
});

export default connect(mapStateToProps)(PersonList); 